import { useUserStore } from "../../state";
import { useCompanyStore } from "../../state/useCompanyStore";
import TourGuideComponent from "./SideBar";

export const useListInventoryTourGuide = () => {
  const { setListInventory, company: user, updateProfile } = useCompanyStore();
  const tourGuideOptions = {
    showProgress: false,
    disableBeacon: true,
    styles: {
      tooltip: { background: "#ffffff" },
      beaconInner: { background: "#ffffff" },
    },
    placement: "bottom" as const,
    locale: {
      skip: (
        <span
          onClick={() => {
            setListInventory(false);
          }}
          className="text-[#344054]"
        >
          Skip
        </span>
      ),
      next: <span className="text-[#ffffff] bg-transparent">Next</span>,
    },
  };
  const listInventoryTourGuide = [
    {
      target: "#list-archive-button",
      content: (
        <TourGuideComponent
          body="Temporarily pause items, product that are not in use"
          progress="Step 1 of 2"
          title="Archived inventory"
        />
      ),
      hideBackButton: true,
      scrollOffset: 80,
      ...tourGuideOptions,
    },
    {
      target: "#list-metric-button",
      content: (
        <TourGuideComponent
          body="You can toggle off your metrics to see just the inventory table"
          progress="Step 2 of 2"
          title="Hide Metrics"
        />
      ),
      placement: "bottom" as const,
      locale: {
        skip: <span className="text-[#344054]">Skip</span>,
        next: <span className="text-[#ffffff] bg-transparent">Next</span>,
        last: (
          <span
            onClick={() => {
              setListInventory(false);
              updateProfile({
                prefs: {
                  ...user.prefs,
                  isFirstInventory: false,
                },
              });
            }}
            className="text-[#ffffff] bg-transparent"
          >
            Finish up
          </span>
        ),
      },
      showProgress: false,
      scrollOffset: 80,
      styles: {
        tooltip: { background: "#ffffff" },
        beaconInner: { background: "#ffffff" },
      },
    },
  ];

  return { listInventoryTourGuide };
};
